import React from "react";

const ICONS = {
  youtube: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2.5" y="5.5" width="19" height="13" rx="3.5" />
      <path d="M10.5 9.3v5.4l4.6-2.7Z" fill="currentColor" stroke="none" />
    </svg>
  ),
  instagram: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17" cy="7" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  ),
  facebook: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 8.5h2V5h-2.3C12.6 5 11 6.6 11 8.7V11H9v3h2v6.5h3V14h2.3l.7-3H14v-1.7c0-.5.3-.8.8-.8Z" />
    </svg>
  ),
  globe: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5c2.2 2.3 3.4 5.3 3.4 8.5s-1.2 6.2-3.4 8.5c-2.2-2.3-3.4-5.3-3.4-8.5S9.8 5.8 12 3.5Z" />
    </svg>
  ),
  // Icone generico de "conversa" (nao o logo oficial do WhatsApp) -- usado pro
  // card de contato via Barnabe nos canais da igreja (pedido do Rodrigo, 10/2026).
  whatsapp: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 4a8 8 0 0 0-6.9 12.1L4 20l4-1.1A8 8 0 1 0 12 4Z" />
      <path d="M9 10.2c.3 1.9 1.9 3.5 3.8 3.8" />
    </svg>
  )
};

const BG = { youtube: "#d64545", instagram: "#8b7cff", facebook: "#3e82ff", globe: "#f08a3c", whatsapp: "#25D366" };

export function ChannelIcon({ icon }) {
  return ICONS[icon] || null;
}

export function channelIconBg(icon) {
  return BG[icon] || "#e6b15a";
}
